import { Serializer } from "jsonapi-serializer";
import { CreateUserInfo, DeleteUserInfo, UpdateUserInfo } from "../../api/typings/Users";
import { IApiResourceResponse } from "../../@typings/client";
import { FormatPhone } from "../../helpers/formatPhone";

export async function getCreateUserData(data: CreateUserInfo): Promise<IApiResourceResponse<CreateUserInfo>> {
  return new Serializer("users", {
    keyForAttribute: "snake_case",
    attributes: ["firstname", "lastname", "phone", "email", "password", "source"],
    transform(record: any) {
      if (record.phone !== "") {
        record.phone = FormatPhone.toDigits(record.phone);
      }
      return record;
    },
  }).serialize(data);
}

export async function getDeleteUserData<TDate = string>(
  data: DeleteUserInfo<TDate>
): Promise<IApiResourceResponse<DeleteUserInfo<TDate>>> {
  return new Serializer("users", {
    keyForAttribute: "snake_case",
    attributes: ["deleted_at"],
  }).serialize(data);
}

export async function getUpdateUserData(data: UpdateUserInfo): Promise<IApiResourceResponse<UpdateUserInfo>> {
  return new Serializer("users", {
    keyForAttribute: "snake_case",
    attributes: ["firstname", "lastname", "phone", "email", "password", "additional_phones", "additional_emails"],
    transform(record: any) {
      if (record.phone !== "") {
        record.phone = FormatPhone.toDigits(record.phone);
      }
      record.additional_phones = record.additional_phones
        ?.filter((phone: string) => !!phone)
        .map((phone: string) => FormatPhone.toDigits(phone));
      record.additional_phones = record.additional_phones?.length === 0 ? null : record.additional_phones;

      record.additional_emails = record.additional_emails?.filter((email: string) => !!email);
      record.additional_emails = record.additional_emails?.length === 0 ? null : record.additional_emails;

      return record;
    },
  }).serialize(data);
}
